import { ChatStatus } from '@rematter/frontend-lib-api-client/grpc/assistant/v1/assistant_pb';
import { ChatArchivedEvent } from '@rematter/frontend-lib-api-client/grpc/assistant/v1/events_pb';
import { BadgeField, Col, FieldDisplay, IDField } from '@rematter/ui-web';

import { useTranslations } from '../../../i18n/useTranslations';
import { chatStatusColors } from '../enumLabels';

type ChatArchivedDetailProps = {
  event: ChatArchivedEvent;
};

//
// ⚛️ ⚛️ ⚛️ CHAT ARCHIVED DETAIL ⚛️ ⚛️ ⚛️
//
export const ChatArchivedDetail = ({ event }: ChatArchivedDetailProps) => {
  const t = useTranslations();

  const chat = event.chat;

  const chatStatusLabels: Record<ChatStatus, string> = {
    [ChatStatus.UNSPECIFIED]: t.logs.chatStatus.unspecified,
    [ChatStatus.ACTIVE]: t.logs.chatStatus.active,
    [ChatStatus.ARCHIVED]: t.logs.chatStatus.archived,
  };

  if (!chat) {
    return (
      <Col className="@ChatArchivedDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.logs.noDataAvailable}</span>
      </Col>
    );
  }

  return (
    <Col className="@ChatArchivedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.logs.archivedChat}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label={t.logs.fields.id} value={chat.id?.value} />
          <FieldDisplay label={t.logs.fields.title} value={chat.title} />
          <BadgeField
            label={t.logs.fields.status}
            value={chatStatusLabels[chat.status]}
            color={chatStatusColors[chat.status]}
          />
          <IDField label={t.logs.fields.agentId} value={chat.agentId?.value} />
          <IDField label={t.logs.fields.userId} value={chat.userId?.value} />
        </div>
      </Col>
    </Col>
  );
};
